// Date/time helpers extracted from EditSurvey

export const pad2 = (n) => String(n).padStart(2, "0");

export function localDateFromISO(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

export function localTimeFromISO(iso) {
    if (!iso) return "";
    const d = new Date(iso);
    if (isNaN(d.getTime())) return "";
    return `${pad2(d.getHours())}:${pad2(d.getMinutes())}`;
}

export function todayLocalDate() {
    const now = new Date();
    return `${now.getFullYear()}-${pad2(now.getMonth() + 1)}-${pad2(now.getDate())}`;
}

export function composeISOFromLocal(dateStr, timeStr) {
    if (!dateStr) return "";
    const [y, m, d] = dateStr.split("-").map((s) => parseInt(s, 10));
    const [hh, mm] = (timeStr || "00:00").split(":").map((s) => parseInt(s, 10));
    const dt = new Date(y, (m || 1) - 1, d || 1, hh || 0, mm || 0, 0);
    return dt.toISOString(); // store as UTC ISO
}

export function isValidDateStr(s) {
    if (!s || typeof s !== "string") return false;
    const m = s.match(/^\d{4}-\d{2}-\d{2}$/);
    if (!m) return false;
    const [y, mo, d] = s.split("-").map((x) => parseInt(x, 10));
    if (mo < 1 || mo > 12) return false;
    if (d < 1 || d > 31) return false;
    if (y < 1900 || y > 3000) return false;
    return true;
}

export function isValidTimeStr(s) {
    if (!s || typeof s !== "string") return false;
    const m = s.match(/^\d{2}:\d{2}$/);
    if (!m) return false;
    const [hh, mm] = s.split(":").map((x) => parseInt(x, 10));
    if (hh < 0 || hh > 23) return false;
    if (mm < 0 || mm > 59) return false;
    return true;
}
